import { createPhaseAction } from 'src/helpers/redux';

import * as paymentServiceTypes from 'src/services/RomanticAI/payment/types';

export const PREFIX = 'payment';
export const SAGA = `${PREFIX}/saga`;

export const actions = {
  postCreateCheckoutSession: createPhaseAction<{
    dialogId?: number;
    reason?: string;
    message_id?: string;
    is_old?: boolean;
    botName?:string;
    priority_category?:string;
    is_upgrade?: boolean;
    paywall_name:'subscription' | 'subscription_sexmode';
    price_id: paymentServiceTypes.IPostCreateCheckoutSessionParams['price_id'];
  }>(`${SAGA}/postCreateCheckoutSession`),

  clearCheckoutSession: createPhaseAction<void>(`${SAGA}/clearCheckoutSession`),

  postCreatePortalSession: createPhaseAction<{
    price_id?: string;
    reason?: string;
  }>(`${SAGA}/postCreatePortalSession`),

  clearPortalSession: createPhaseAction<void>(`${SAGA}/clearPortalSession`),

  postHeartCreateCheckoutSession: createPhaseAction<{
    dialogId?: number;
    reason?: string;
    message_id?:string;
    botName?: string;
    bot_category?: string;
    count: number | string;
    price_id: paymentServiceTypes.IPostCreateCheckoutSessionParams['price_id'];
  }>(`${SAGA}/postHeartCreateCheckoutSession`),
  clearHeartCheckoutSession: createPhaseAction<void>(
    `${SAGA}/clearHeartCheckoutSession`
  ),

  getWallet: createPhaseAction<void>(`${SAGA}/getWallet`),
  getProducts: createPhaseAction<void>(`${SAGA}/getProducts`),
  getPaymentOptions: createPhaseAction<void>(`${SAGA}/getPaymentOptions`),
  getFinpaymeProducts: createPhaseAction<void>(`${SAGA}/getFinpaymeProducts`),
  postFinpaymeInvoice: createPhaseAction<{
    product_id: number;
    product_type: paymentServiceTypes.TPaymentProductType;
    payment_method?: paymentServiceTypes.TFinpaymePaymentMethod;
    consumables?: number;
  }>(`${SAGA}/postFinpaymeInvoice`),
  finpaymeAwaitResult: createPhaseAction<void>(`${SAGA}/finpaymeAwaitResult`),
  postOrder: createPhaseAction<void>(`${SAGA}/postOrder`),
  stripeChange: createPhaseAction<paymentServiceTypes.IChangeSubscriptionEvent>(`${SAGA}/stripeChange`),
  getProductsGroups:  createPhaseAction<paymentServiceTypes.IGetProductsGroupsParams>(`${SAGA}/getProductsGroups`),
};
